import * as EvmChains from '@/assets/data/evm_chains.json';

const tokenDir = {
  USDT: {
    Symbol: 'USDT',
    Name: 'Tether',
    Decimal: 6,
  },
  USDC: {
    Symbol: 'USDC',
    Name: 'USD Coin',
    Decimal: 6,
  },
};

const BLOCK_EXPLORER = {
  ZKSYNC: 'https://zkscan.io/explorer/transactions/',
  'ZKSYNC-RINKEBY': 'https://rinkeby.zkscan.io/explorer/transactions/',
};

export const getTokenDecimal = (coin) => tokenDir[coin]?.Decimal;

export const getBlockExplorerURL = (chainName) => {
  const url = BLOCK_EXPLORER[chainName];
  return url === undefined ? '' : url;
};

export const isNativeCoin = (coin, chainId) => {
  const evmChains = Object.values(EvmChains);
  const chain = evmChains[0].find((evm) => evm.chainId === chainId);
  if (chain === undefined) {
    return false;
  }
  return chain.nativeCurrency.symbol === coin;
};

export const getNativeTokenDecimal = (chainId) => {
  const evmChains = Object.values(EvmChains);
  const chain = evmChains[0].find((evm) => evm.chainId === chainId);
  return chain.nativeCurrency.decimals;
};

export const getRpcUrl = (chainId) => {
  const evmChains = Object.values(EvmChains);
  const chain = evmChains[0].find((evm) => evm.chainId === chainId);
  const rpcURL = chain.rpcUrls[0];
  // eslint-disable-next-line no-template-curly-in-string
  return rpcURL.replace('${INFURA_API_KEY}', process.env.VITE_INFURA_KEY);
};
